// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) {});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});

/*hero banner home */
document.addEventListener("DOMContentLoaded", function () {
    const overlayContent = document.querySelector(
        ".hero-banner-home .overlay-content",
    );
    const videoContainer = document.querySelector(
        ".hero-banner-home .video-container",
    );
    const maxWidth = 767.98;

    if (!overlayContent || !videoContainer) {
        return;
    }

    let bgColor = window.getComputedStyle(overlayContent).backgroundColor;
    let opacity = window.getComputedStyle(overlayContent).opacity;
    let bgColor50 = bgColor.replace("rgb", "rgba").replace(")", ", 0.5)");

    function adjustHeroBanner() {
        if (window.innerWidth <= maxWidth) {
            if (overlayContent && videoContainer) {
                if (bgColor.startsWith("rgb")) {
                    videoContainer.style.backgroundColor = bgColor;
                    overlayContent.style.background = `linear-gradient(0deg, ${bgColor} 0%, ${bgColor50} 100%)`;
                    overlayContent.style.aspectRatio = "1/1";
                    overlayContent.style.height = "auto";
                    overlayContent.style.opacity = "1";
                }
            }
        } else {
            if (overlayContent && videoContainer) {
                overlayContent.style.background = bgColor;
                overlayContent.style.opacity = opacity;
                overlayContent.style.aspectRatio = "";
                overlayContent.style.height = "";
                videoContainer.style.backgroundColor = "";
            }
        }
    }

    adjustHeroBanner();
    window.addEventListener("resize", adjustHeroBanner);
});
jQuery(document).ready(function ($) {
    $(".js-dropdown-toggle").on("click", function () {
        const $dropdown = $(this).closest(".dropdown-custom");
        $dropdown.toggleClass("is-open");
    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest(".dropdown-custom").length) {
            $(".dropdown-custom").removeClass("is-open");
        }
    });
});

function initFakePlaceholders() {
    document
        .querySelectorAll(
            'input[placeholder*="*"], select, textarea, #input_1_14, textarea[placeholder*="*"]',
        )
        .forEach((field) => {
            if (field.parentNode.classList.contains("fake-placeholder-wrapper"))
                return;

            let text = "";
            let showStar = false;
            if (field.tagName === "INPUT" || field.tagName === "TEXTAREA") {
                if (field.placeholder.includes("*")) {
                    text = field.placeholder.replace("*", "").trim();
                    showStar = true;
                    field.placeholder = "";
                } else if (field.placeholder !== "") {
                    // If placeholder but NO asterisk (like your textarea)
                    text = field.placeholder.trim();
                    field.placeholder = "";
                    showStar = false;
                } else {
                    return;
                }
            }

            if (field.tagName === "SELECT") {
                const firstOption = field.options[0];
                if (!firstOption || !firstOption.text.includes("*")) return;
                text = firstOption.text.replace("*", "").trim();
                showStar = true;
                firstOption.text = "";
                firstOption.disabled = true;
                firstOption.hidden = true;
            }

            // --- Wrapper and Fake Placeholder ---
            const wrapper = document.createElement("div");
            wrapper.style.position = "relative";
            wrapper.classList.add("fake-placeholder-wrapper");

            const fake = document.createElement("div");
            fake.className = "fake-placeholder";
            fake.innerHTML = showStar
                ? `${text}<span class="required">*</span>`
                : text;

            field.parentNode.insertBefore(wrapper, field);
            wrapper.appendChild(field);
            wrapper.appendChild(fake);

            const updateVisibility = () => {
                fake.style.display = field.value ? "none" : "block";
            };

            // Events
            field.addEventListener(
                "focus",
                () => (fake.style.display = "none"),
            );
            field.addEventListener("blur", updateVisibility);
            field.addEventListener("input", updateVisibility);
            field.addEventListener("change", updateVisibility);

            updateVisibility();
        });
}

document.addEventListener("DOMContentLoaded", function () {
    initFakePlaceholders();
});

// Re-run on Gravity Forms render (AJAX or Validation)
if (typeof jQuery !== "undefined") {
    jQuery(document).on("gform_post_render", function () {
        initFakePlaceholders();
    });
}

//hero slider insights
document.addEventListener("DOMContentLoaded", function () {
    const swiperInsights = new Swiper(".hero-slider-wrapper", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".hero-slider-controls .pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".hero-slider-controls .button-next",
            prevEl: ".hero-slider-controls .button-prev",
        },
    });
});

/*slider card top image*/
document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".slider-card-top-image");

    sliders.forEach((section) => {
        const swiperContainer = section.querySelector(".mySwiper-slider-card");
        const nextBtn = section.querySelector(
            ".slider-cards-footer__arrow--next",
        );
        const prevBtn = section.querySelector(
            ".slider-cards-footer__arrow--prev",
        );
        const currentCount = section.querySelector(
            ".slider-cards-footer__counter-current",
        );
        const totalCount = section.querySelector(
            ".slider-cards-footer__counter-total",
        );

        if (swiperContainer) {
            new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                },
                on: {
                    init: function (swiper) {
                        if (totalCount) {
                            totalCount.textContent = swiper.slides.length;
                        }
                        if (currentCount) {
                            currentCount.textContent = swiper.activeIndex + 1;
                        }
                    },
                    slideChange: function (swiper) {
                        if (currentCount) {
                            currentCount.textContent = swiper.activeIndex + 1;
                        }
                    },
                },
            });
        }
    });
});

/*side accordion*/
document.addEventListener("DOMContentLoaded", function () {
    const accordionsSections = document.querySelectorAll(".side-accordion");

    accordionsSections.forEach((section) => {
        const items = section.querySelectorAll(".side-accordion__item");
        const images = section.querySelectorAll(".side-accordion__bg");

        items.forEach((item, index) => {
            const heading = item.querySelector(".side-accordion__heading");
            const marker = item.querySelector(".circle-wrap");

            const activateItem = () => {
                items.forEach((i) => i.classList.remove("active"));
                item.classList.add("active");

                if (images.length > 0) {
                    images.forEach((img) => img.classList.remove("active"));
                    if (images[index]) {
                        images[index].classList.add("active");
                    }
                }
            };

            if (heading) {
                heading.addEventListener("click", activateItem);
            }

            if (marker) {
                marker.addEventListener("click", activateItem);
            }
        });
    });
});

jQuery(document).ready(function ($) {
    $(".related-posts__slider").on("init", function (event, slick) {
        if (typeof AOS !== "undefined") {
            AOS.refresh();
        }
    });
    $(".related-posts__slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        prevArrow: $(".related-posts-arrows .prev-arrow"),
        nextArrow: $(".related-posts-arrows .next-arrow"),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                },
            },
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
});

jQuery(document).ready(function ($) {
    const $slider = $(".stats-slider");
    const $counterCurrent = $(".stats-slider-counter .current");
    const $counterTotal = $(".stats-slider-counter .total");

    function initStatsSlider() {
        if (window.innerWidth <= 767) {
            if (!$slider.hasClass("slick-initialized")) {
                $slider.on("init", function (event, slick) {
                    $counterTotal.text(slick.slideCount);
                    $counterCurrent.text(slick.currentSlide + 1);
                });

                $slider.on(
                    "afterChange",
                    function (event, slick, currentSlide) {
                        $counterCurrent.text(currentSlide + 1);
                    },
                );

                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    dots: false,
                    infinite: true,
                    adaptiveHeight: true,
                    prevArrow: $(".stats-slider-arrows .prev-arrow"),
                    nextArrow: $(".stats-slider-arrows .next-arrow"),
                });
            }
        } else {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }
        }
    }

    initStatsSlider();
    $(window).on("resize", initStatsSlider);
});

document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll(".vt-tab-title");

    titles.forEach((title) => {
        title.addEventListener("click", () => {
            const tab = title.dataset.tab;
            document
                .querySelectorAll(".vt-tab-title")
                .forEach((el) => el.classList.remove("active"));
            document
                .querySelectorAll(".vt-center-panel")
                .forEach((el) => el.classList.remove("active"));
            document
                .querySelectorAll(".vt-bg-item")
                .forEach((el) => el.classList.remove("active"));

            title.classList.add("active");
            document
                .querySelector('.vt-center-panel[data-tab="' + tab + '"]')
                ?.classList.add("active");
            document
                .querySelector('.vt-bg-item[data-tab="' + tab + '"]')
                ?.classList.add("active");
        });
    });
});
document.addEventListener("DOMContentLoaded", function () {
    function initVTSliders() {
        if (window.innerWidth > 767) return;

        document
            .querySelectorAll(".vt-mobile-slider")
            .forEach(function (slider) {
                if (slider.classList.contains("slick-initialized")) return;
                jQuery(slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    arrows: false,
                    dots: false,
                });
            });
    }

    initVTSliders();
    window.addEventListener("resize", initVTSliders);
});
//CTA Slider Image Text
document.addEventListener("DOMContentLoaded", function () {
    const swiperInsights = new Swiper(".slider-image-text__slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".slider-image-text__inner--controls .pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".slider-image-text__inner--controls .button-next",
            prevEl: ".slider-image-text__inner--controls .button-prev",
        },
    });
});
//slider case studies
document.addEventListener("DOMContentLoaded", function () {
    const swiperInsights = new Swiper(".slider-case-studies__slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".slider-case-studies__inner--controls .pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".slider-case-studies__inner--controls .button-next",
            prevEl: ".slider-case-studies__inner--controls .button-prev",
        },
    });
});

//Accordion FAQs
document.addEventListener("DOMContentLoaded", function () {
    let userInteracted = false;
    window.addEventListener("click", function () { userInteracted = true; }, { once: true });

    document.querySelectorAll(".accordion-item").forEach((item) => {
        item.addEventListener("toggle", (event) => {
            if (item.open && userInteracted) {
                setTimeout(() => {
                    item.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                    });
                }, 50);
            }
        });
    });
});

// Slider Partners Relations
jQuery(document).ready(function ($) {
    var $slider = $(".partnership-slider");
    var $counterCurrent = $(".partnership-slider__counter-current");
    var $counterTotal = $(".partnership-slider__counter-total");

    var $prev = $(".partnership-slider__arrow--prev");
    var $next = $(".partnership-slider__arrow--next");

    $slider.on(
        "init reInit afterChange",
        function (event, slick, currentSlide) {
            var slideIndex = currentSlide || 0;

            var slidesToShow = slick.options.slidesToShow;
            var totalSlides = slick.slideCount - slidesToShow + 1;

            var current = slideIndex + 1;
            var lastSlide = totalSlides - 1;

            $counterCurrent.text(current);
            $counterTotal.text(totalSlides);

            // reset
            $prev.css({ opacity: "1", "pointer-events": "auto" });
            $next.css({ opacity: "1", "pointer-events": "auto" });

            // FIRST
            if (slideIndex === 0) {
                $prev.css({ opacity: "0.5", "pointer-events": "none" });
            }

            // LAST
            if (slideIndex >= lastSlide) {
                $next.css({ opacity: "0.5", "pointer-events": "none" });
            }
        },
    );

    if (typeof AOS !== "undefined") {
        $slider.on("init", function () {
            setTimeout(function () {
                AOS.refresh();
            }, 500);
        });
    }

    $slider.slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    // Custom Navigation
    $prev.click(function () {
        $slider.slick("slickPrev");
    });

    $next.click(function () {
        $slider.slick("slickNext");
    });
});

//photo carousel
document.addEventListener("DOMContentLoaded", function () {
    if (typeof jQuery === "undefined") return;
    if (typeof jQuery.fn.slick === "undefined") return;

    jQuery(".photo-carousel__slider").each(function () {
        var $slider = jQuery(this);
        var $wrapper = $slider.closest(".photo-carousel__wrapper");

        if ($slider.hasClass("slick-initialized")) return;

        $slider.slick({
            infinite: true,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: true,
            centerPadding: "220px",
            speed: 500,
            arrows: true,
            prevArrow: $wrapper.find(".photo-carousel__arrow--prev"),
            nextArrow: $wrapper.find(".photo-carousel__arrow--next"),

            responsive: [
                {
                    breakpoint: 650,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        centerPadding: "0px",
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });
});

// large square grid
document.addEventListener("DOMContentLoaded", function () {
    if (typeof jQuery === "undefined") return;

    function initMagnific($grid) {
        if (typeof jQuery.fn.magnificPopup === "undefined") return;
        if ($grid.data("mfp-initialized")) return;

        $grid.data("mfp-initialized", true);

        $grid.magnificPopup({
            delegate: "a.large-square-grid__link",
            type: "image",
            gallery: {
                enabled: false,
            },
            closeOnContentClick: true,
            image: {
                titleSrc: function (item) {
                    return item.el.attr("title") || "";
                },
            },
            closeOnContentClick: false,
            mainClass: "mfp-fade",
            removalDelay: 200,
        });
    }

    function initSlick($wrapper, $grid) {
        if (typeof jQuery.fn.slick === "undefined") return;

        var isMobile = window.matchMedia("(max-width: 767px)").matches;

        if (isMobile) {
            if ($grid.hasClass("slick-initialized")) return;

            $grid.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: true,
                prevArrow: $wrapper.find(".large-square-grid__arrow--prev"),
                nextArrow: $wrapper.find(".large-square-grid__arrow--next"),
                dots: false,
                adaptiveHeight: true,
            });
        } else {
            if (!$grid.hasClass("slick-initialized")) return;
            $grid.slick("unslick");
        }
    }

    function initLargeSquareGrid() {
        jQuery(".large-square-grid__wrapper").each(function () {
            var $wrapper = jQuery(this);
            var $grid = $wrapper.find(".large-square-grid__grid");

            initMagnific($grid);
            initSlick($wrapper, $grid);
        });
    }

    initLargeSquareGrid();

    window.addEventListener("resize", function () {
        initLargeSquareGrid();
    });
});

//small-squre-gallery
jQuery(function ($) {
    $(".js-mfp-gallery").each(function () {
        $(this).magnificPopup({
            delegate: "a.js-mfp-item",
            type: "image",
            gallery: {
                enabled: false,
            },
            closeOnContentClick: true,
            mainClass: "mfp-fade",
            removalDelay: 200,
        });
    });
});
